import { ChangeDetectionStrategy, Component, Input, TrackByFunction } from '@angular/core'
import { Tag } from './tags.interface'
import { CollectionTabUriPart } from './tags.utility'

@Component({
  selector: 'flo-tags',
  templateUrl: './tags.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsComponent {
  private _tags: ReadonlyArray<Tag> | undefined

  @Input()
  get tags(): ReadonlyArray<Tag> | undefined {
    return this._tags
  }

  set tags(tags: ReadonlyArray<Tag> | undefined) {
    /**
     *  Validate input is an array and not empty
     */
    this._tags = Array.isArray(tags) && !!tags.length ? tags : undefined
  }

  public readonly trackByTag: TrackByFunction<Tag> = (index: number, item: Tag) => {
    return item.name
  }

  @Input()
  collectionTabUriPart: CollectionTabUriPart = '/article'
}
